// Keep the existing buttons and use the installed provider when ready.
// Product Buy now has already added the selected variant before this call.
export function requestCheckout(button, context, cart) {
  const proceed = document.dispatchEvent(new CustomEvent('sanjar:checkout', { cancelable: true, detail: { button, context, cart } }));
  if (!proceed) return false;
  // FasTrr's current integration uses retail prices, not company catalog prices.
  if (document.getElementById('sellerDomain')?.dataset.b2b === 'true') return true;
  if (typeof window.HeadlessCheckout?.checkout === 'function') {
    try {
      // Use cart checkout here: calling buyNow would add the product twice.
      const drawer = button?.closest('theme-drawer');
      if (drawer?.hasAttribute('open') && typeof drawer.close === 'function') {
        if (button.dataset.checkoutPending === 'true') return false;
        button.dataset.checkoutPending = 'true';
        button.setAttribute('aria-busy', 'true');
        // FasTrr renders outside the native modal, so close the drawer first.
        Promise.resolve(drawer.close()).then(() => window.HeadlessCheckout.checkout()).catch(() => {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
        }).finally(() => {
          delete button.dataset.checkoutPending;
          button.removeAttribute('aria-busy');
        });
      } else {
        window.HeadlessCheckout.checkout();
      }
      return false;
    } catch (error) {
      console.warn('FasTrr could not open; using Shopify checkout.', error);
    }
  }
  return true;
}
if (!window.sanjarCheckoutListener) {
  window.sanjarCheckoutListener = true;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.defaultPrevented) return;
    const button = event.target.closest('[data-sl-checkout]');
    if (button && !requestCheckout(button, 'cart')) event.preventDefault();
  });
}
